import { ElementType, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { visuallyHiddenCss } from './a11y';

/**
 * Used to give icon-only or spinner-only controls an accessible name/label
 * without showing text. See `visuallyHiddenCss` (a11y.ts) for the pattern
 * itself, shared with other primitives that can't just wrap in this `span`.
 */
const Hidden = styled.span`
  ${visuallyHiddenCss}
`;

export interface VisuallyHiddenProps {
  /** Render as a different element/component than the default `span`. */
  as?: ElementType;
  className?: string;
}

export function VisuallyHidden({ as, className, children }: PropsWithChildren<VisuallyHiddenProps>) {
  return (
    <Hidden as={as} className={className}>
      {children}
    </Hidden>
  );
}

export default VisuallyHidden;
